export const environment = {
  // Never enable outside local development.
  devAuth: {
    enabled: false,
    defaultUser: '',
  },
  socketPath: '/socket.io',
  serverHost: 'https://devSeguroPersonaApi.lacolonial.com.do/',
  mapsKey: 'AIzaSyDjZu-yR3TJwMWpwXEPpis6s0xBMCUYs6I',
  msalConfig: {
    auth: {
      clientId: '4af6289b-e887-44e4-bda7-e7452ade21cd',
    },
  },
  apiConfig: {
    scopes: [
      'offline_access',
      'openid',
       'https://labloginlacolonial.onmicrosoft.com/e492184f-0e13-4d5f-b2e5-7584cbcb0946/SeguroPersona.Read',
      'https://labloginlacolonial.onmicrosoft.com/e492184f-0e13-4d5f-b2e5-7584cbcb0946/SeguroPersona.ReadWrite',
    ],
    uri: '',
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1_SignIn',
      signUp: 'B2C_1_SignUpLive',
    },
    authorities: {
      signUpSignIn: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_SignIn',
      },
      signUp: {
        authority:
          'https://labloginlacolonial.b2clogin.com/labloginlacolonial.onmicrosoft.com/B2C_1_SignUpLive',
      },
    },
    authorityDomain: 'labloginlacolonial.b2clogin.com',
  },
  paymentRoute: 'https://DevEpaymentProxyAPI.lacolonial.com.do/api/',
  claimsRoute: 'https://DevDigitalClaimAPI.lacolonial.com.do/api/',
  apiRoute: 'https://devSeguroPersonaApi.lacolonial.com.do/api/',
  identityRoute: 'https://cololel-identity-stage.azurewebsites.net/',
  cmsRoute: 'wp-json/wp/v2/',
};
